const ProductMap = {
	TOYSCNCTXBP010120160509: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Toyota Safety Connect - Monthly Recurring",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXBP010120170629: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Toyota Safety Connect - Monthly Recurring",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXBP000020160429: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXBP000020170629: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXBP121220160509: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Toyota Safety Connect - 12 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXBP241220160509: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Toyota Safety Connect - 24 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXBP361220160509: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Toyota Safety Connect - 36 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXBP481220160509: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Toyota Safety Connect - 48 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXBP601220160509: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Toyota Safety Connect - 60 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXBP721220160509: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Toyota Safety Connect - 72 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXBP121220170629: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Toyota Safety Connect - 12 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXBP241220170629: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Toyota Safety Connect - 24 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXFP121220080717: {
		version: "Legacy",
		category: "Safety connect (navi)",
		productName: "Safety Connect Included First Year - 12 Months",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: false,
	},
	TOYSCNCTAGW010020080717: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Safety Connect - Goodwill 1 Month - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTAGW030020080717: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Safety Connect - Goodwill 3 Months - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTAGW060020080717: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Safety Connect - Goodwill 6 Months - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTAGW120020080717: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Safety Connect - Goodwill 12 Months - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXPM030020080717: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Safety Connect",
		billing: "Promotion",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXPM060020080717: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Safety Connect",
		billing: "Promotion",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXPM090020080717: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Safety Connect",
		billing: "Promotion",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXPM120020080717: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Safety Connect",
		billing: "Promotion",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXPM150020080717: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Safety Connect",
		billing: "Promotion",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXSS030020080717: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Safety Connect",
		billing: "Subscription Save",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTTGW010020080717: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Safety Connect - Goodwill 1 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTTGW030020080717: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Safety Connect - Goodwill 3 Months",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTTGW120020080717: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Safety Connect - Goodwill 12 Months",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTXBP010120160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - Monthly Recurring",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTXBP010120170629: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - Monthly Recurring",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTXBP000020160429: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTXBP000020170629: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTXBP121220160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - 12 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTXBP241220160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - 24 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTXBP361220160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - 36 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTXBP481220160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - 48 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTXBP601220160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - 60 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTXBP721220160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - 72 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTXBP121220170629: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - 12 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTXBP241220170629: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - 24 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTXFP121220160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect Included First Year - 12 Months",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTAGW010020160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - Goodwill 1 Month - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTAGW030020160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - Goodwill 3 Months - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTAGW060020160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - Goodwill 6 Months - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTAGW120020160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - Goodwill 12 Months - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTTGW010020160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - Goodwill 1 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTTGW030020160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - Goodwill 3 Months",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTTGW060020160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - Goodwill 6 Months",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSCNCTTGW120020160615: {
		version: "Legacy",
		category: "Safety connect (non-navi)",
		productName: "Lexus Safety Connect - Goodwill 12 Months",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTXFP361220080717: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Safety Connect Included First Year - 36 Months",
		billing: "OEM EV Trial",
		isTrial: true,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSCNCTTGW060020080717: {
		version: "Legacy",
		category: "Safety Connect (EV)",
		productName: "Safety Connect - Goodwill 6 Months",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXENFRMXBP010120160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - Monthly Recurring",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMXBP010120170629: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - Monthly Recurring",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMXBP000020160429: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMXBP000020170629: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMXBP121220160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - 12 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMXBP241220160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - 24 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMXBP361220160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - 36 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMXBP481220160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - 48 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMXBP601220160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - 60 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMXBP721220160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - 72 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMXBP121220170629: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - 12 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMXBP241220170629: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - 24 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMXFP121220160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName:
			"Lexus Safety With Destinations Included First Year - 12 Months",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMAGW010020160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - Goodwill 1 Month - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMAGW030020160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - Goodwill 3 Months - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMAGW060020160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - Goodwill 6 Months - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMAGW120020160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - Goodwill 12 Months - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMTGW010020160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - Goodwill 1 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMTGW030020160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - Goodwill 3 Months",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMTGW060020160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - Goodwill 6 Months",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMTGW120020160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations - Goodwill 12 Months",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXENFRMXFP241220160615: {
		version: "Legacy",
		category: "Safety with Destinations (navi)",
		productName: "Lexus Safety With Destinations Included Two Year - 24 Months",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: true,
		remote: false,
	},
	LEXSCNRSXBP010120160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - Monthly Recurring",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSXBP010120170629: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - Monthly Recurring",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSXBP000020160429: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSXBP000020170629: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSXBP121220160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - 12 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSXBP241220160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - 24 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSXBP361220160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - 36 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSXBP481220160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - 48 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSXBP601220160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - 60 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSXBP721220160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - 72 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSXBP121220170629: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - 12 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSXBP241220170629: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - 24 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSXFP121220160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote Included First Year - 12 Months",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSAGW010020160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - Goodwill 1 Month - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSAGW030020160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - Goodwill 3 Months - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSAGW060020160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - Goodwill 6 Months - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSAGW120020160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - Goodwill 12 Months - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSTGW010020160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - Goodwill 1 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSTGW030020160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - Goodwill 3 Months",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSTGW060020160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - Goodwill 6 Months",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXSCNRSTGW120020160615: {
		version: "Legacy",
		category: "Safety with Remote (navi)",
		productName: "Lexus Safety With Remote - Goodwill 12 Months",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: true,
	},
	LEXENFRSXBP010120160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "Lexus Safety + Remote + Destinations - Monthly Recurring",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSXBP010120170629: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "Lexus Safety + Remote + Destinations - Monthly Recurring",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSXBP000020160429: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSXBP000020170629: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSXBP121220160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "Lexus Safety + Remote + Destinations - 12 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSXBP241220160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "Lexus Safety + Remote + Destinations - 24 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSXBP361220160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "Lexus Safety + Remote + Destinations - 36 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSXBP481220160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "Lexus Safety + Remote + Destinations - 48 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSXBP601220160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "Lexus Safety + Remote + Destinations - 60 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSXBP721220160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "Lexus Safety + Remote + Destinations - 72 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSXBP121220170629: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "Lexus Safety + Remote + Destinations - 12 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSXBP241220170629: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "Lexus Safety + Remote + Destinations - 24 Months",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSXFP121220160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName:
			"Lexus Safety + Remote + Destinations Included First Year - 12 Months",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSAGW010020160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName:
			"Lexus Safety + Remote + Destinations - Goodwill 1 Month - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSAGW030020160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName:
			"Lexus Safety + Remote + Destinations - Goodwill 3 Months - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSAGW060020160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName:
			"Lexus Safety + Remote + Destinations - Goodwill 6 Months - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSAGW120020160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName:
			"Lexus Safety + Remote + Destinations - Goodwill 12 Months - SXM",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSTGW010020160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "Lexus Safety + Remote + Destinations - Goodwill 1 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSTGW030020160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "Lexus Safety + Remote + Destinations - Goodwill 3 Months",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSTGW060020160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "Lexus Safety + Remote + Destinations - Goodwill 6 Months",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	LEXENFRSTGW120020160615: {
		version: "Legacy",
		category: "Safety with Destination with Remote",
		productName: "Lexus Safety + Remote + Destinations - Goodwill 12 Months",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: true,
	},
	TOYSAFTYXBP010120150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Paid 1 Month",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYXBP000020160429: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYXBP121220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Paid 1 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYXBP241220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Paid 2 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYXBP361220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Paid 3 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYXBP481220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Paid 4 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYXBP601220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Paid 5 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYXBP721220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Paid 6 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYXFP361220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Trial 3 Year",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYAGW011220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Goodwill SXM 1 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYAGW031220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Goodwill SXM 3 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYAGW061220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Goodwill SXM 6 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYAGW121220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Goodwill SXM 1 Year",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYTGW011220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Goodwill TMNA 1 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYTGW031220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Goodwill TMNA 3 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYTGW061220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Goodwill TMNA 6 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFTYTGW121220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Goodwill TMNA 1 Year",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYXBP010120150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Paid 1 Month",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYXBP000020160429: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYXBP121220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Paid 1 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYXBP241220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Paid 2 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYXBP361220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Paid 3 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYXBP481220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Paid 4 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYXBP601220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Paid 5 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYXBP721220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Paid 6 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYXFP991220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Trial 10 Year",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYAGW011220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Goodwill SXM 1 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYAGW031220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Goodwill SXM 3 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYAGW061220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Goodwill SXM 6 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYAGW121220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Goodwill SXM 1 Year",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYTGW011220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Goodwill TMNA 1 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYTGW031220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Goodwill TMNA 3 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYTGW061220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Goodwill TMNA 6 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	LEXSAFTYTGW121220150528: {
		version: "17CY",
		category: "Safety & Diagnostics",
		productName: "Safety & Service Connect - Lexus Goodwill TMNA 1 Year",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONXBP010120160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Paid 1 Month",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONXBP000020160429: {
		version: "17CY",
		category: "Safety Only",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONXBP121220160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Paid 1 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONXBP241220160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Paid 2 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONXBP361220160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Paid 3 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONXBP481220160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Paid 4 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONXBP601220160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Paid 5 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONXBP721220160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Paid 6 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONXFP361220160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Trial 3 Year",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONAGW011220160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Goodwill SXM 1 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONAGW031220160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Goodwill SXM 3 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONAGW061220160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Goodwill SXM 6 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONAGW121220160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Goodwill SXM 1 Year",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONTGW011220160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Goodwill TMNA 1 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONTGW031220160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Goodwill TMNA 3 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONTGW061220160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Goodwill TMNA 6 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYSAFONTGW121220160323: {
		version: "17CY",
		category: "Safety Only",
		productName: "Safety - Goodwill TMNA 1 Year",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: true,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTIXBP010120150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Paid 1 Month",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTIXBP000020160429: {
		version: "17CY",
		category: "Destination Assist",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTIXBP121220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Paid 1 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTIXBP241220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Paid 2 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTIXBP361220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Paid 3 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTIXBP481220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Paid 4 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTIXBP601220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Paid 5 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTIXBP721220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Paid 6 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTIXFP061220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Trial 6 Month",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTIAGW011220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Goodwill SXM 1 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTIAGW031220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Goodwill SXM 3 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTIAGW061220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Goodwill SXM 6 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTIAGW121220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Goodwill SXM 1 Year",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTITGW011220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Goodwill TMNA 1 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTITGW031220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Goodwill TMNA 3 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTITGW061220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Goodwill TMNA 6 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYDESTITGW121220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Goodwill TMNA 1 Year",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTIXBP010120150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Paid 1 Month",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTIXBP000020160429: {
		version: "17CY",
		category: "Destination Assist",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTIXBP121220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Paid 1 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTIXBP241220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Paid 2 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTIXBP361220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Paid 3 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTIXBP481220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Paid 4 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTIXBP601220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Paid 5 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTIXBP721220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Paid 6 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTIXFP121220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Trial 1 Year",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTIAGW011220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Goodwill SXM 1 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTIAGW031220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Goodwill SXM 3 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTIAGW061220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Goodwill SXM 6 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTIAGW121220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Goodwill SXM 1 Year",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTITGW011220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Goodwill TMNA 1 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTITGW031220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Goodwill TMNA 3 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTITGW061220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Goodwill TMNA 6 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	LEXDESTITGW121220150528: {
		version: "17CY",
		category: "Destination Assist",
		productName: "Destination Assist - Lexus Goodwill TMNA 1 Year",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: true,
		dynamicNavigation: false,
		remote: false,
	},
	TOYHYBRAXBP241220150528: {
		version: "17CY",
		category: "Hybrid Navi A",
		productName: "Dynamic Navigation A - Paid 2 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: false,
	},
	TOYHYBRAXFP361220150528: {
		version: "17CY",
		category: "Hybrid Navi A",
		productName: "Dynamic Navigation A - Trial 3 Year",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: false,
	},
	LEXHYBRAXBP241220150528: {
		version: "17CY",
		category: "Hybrid Navi A",
		productName: "Dynamic Navigation A - Lexus Paid 2 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: false,
	},
	LEXHYBRAXFP361220150528: {
		version: "17CY",
		category: "Hybrid Navi A",
		productName: "Dynamic Navigation A - Lexus Trial 3 Year",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: false,
	},
	TOYHYBRBXBP241220150528: {
		version: "17CY",
		category: "Hybrid Navi B",
		productName: "Dynamic Navigation B - Paid 2 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: false,
	},
	TOYHYBRBXFP361220150528: {
		version: "17CY",
		category: "Hybrid Navi B",
		productName: "Dynamic Navigation B - Trial 3 Year",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: false,
	},
	LEXHYBRBXBP241220150528: {
		version: "17CY",
		category: "Hybrid Navi B",
		productName: "Dynamic Navigation B - Lexus Paid 2 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: false,
	},
	LEXHYBRBXFP361220150528: {
		version: "17CY",
		category: "Hybrid Navi B",
		productName: "Dynamic Navigation B - Lexus Trial 3 Year",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: false,
		serviceConnect: false,
		destinationAssist: false,
		dynamicNavigation: true,
		remote: false,
	},
	TOYREMOTXBP010120150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Paid 1 Month",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTXBP000020160429: {
		version: "17CY",
		category: "Remote Services",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTXBP121220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Paid 1 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTXBP241220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Paid 2 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTXBP361220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Paid 3 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTXBP481220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Paid 4 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTXBP601220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Paid 5 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTXBP721220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Paid 6 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTXFP061220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Trial 6 Month",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTAGW011220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Goodwill SXM 1 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTAGW031220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Goodwill SXM 3 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTAGW061220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Goodwill SXM 6 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTAGW121220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Goodwill SXM 1 Year",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTTGW011220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Goodwill TMNA 1 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTTGW031220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Goodwill TMNA 3 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTTGW061220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Goodwill TMNA 6 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	TOYREMOTTGW121220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Goodwill TMNA 1 Year",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTXBP010120150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Paid 1 Month",
		billing: "Monthly",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTXBP000020160429: {
		version: "17CY",
		category: "Remote Services",
		productName: "N/A - In OBIEE only",
		billing: "Monthly Proration",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTXBP121220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Paid 1 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTXBP241220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Paid 2 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTXBP361220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Paid 3 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTXBP481220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Paid 4 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTXBP601220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Paid 5 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTXBP721220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Paid 6 Year",
		billing: "Regular",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTXFP9121220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Trial 1 Year",
		billing: "OEM Trial",
		isTrial: true,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTAGW011220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Goodwill SXM 1 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTAGW031220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Goodwill SXM 3 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTAGW061220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Goodwill SXM 6 Month",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTAGW121220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Goodwill SXM 1 Year",
		billing: "SXM Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTTGW011220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Goodwill TMNA 1 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTTGW031220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Goodwill TMNA 3 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTTGW061220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Goodwill TMNA 6 Month",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
	LEXREMOTTGW121220150528: {
		version: "17CY",
		category: "Remote Services",
		productName: "Remote Services - Lexus Goodwill TMNA 1 Year",
		billing: "Toyota Comp/Gdwl",
		isTrial: false,
		safetyConnect: false,
		serviceConnect: true,
		destinationAssist: false,
		dynamicNavigation: false,
		remote: true,
	},
};

export const SXMStatus = {
	Inactive: 1,
	Expired: 2,
	Trial: 3,
	Active: 4,
};

export const SXMStatusStrings = {
	1: "INACTIVE",
	2: "EXPIRED",
	3: "TRIAL",
	4: "ACTIVE",
};

export const SXMFeatures = {
	DestinationAssist: "Destination Assist",
	DynamicNavigation: "Dynamic Navigation",
	EnformRemote: "Enform Remote",
	SafetyConnect: "Safety Connect",
	ServiceConnect: "Service Connect",
};

export function getFeatures(subscriptions = []) {
	let destinationAssist = SXMStatus.Inactive;
	let dynamicNavigation = SXMStatus.Inactive;
	let remote = SXMStatus.Inactive;
	let safetyConnect = SXMStatus.Inactive;
	let serviceConnect = SXMStatus.Inactive;

	for (const sub of subscriptions) {
		if (sub.productCode) {
			const product = ProductMap[sub.productCode];
			if (product) {
				const status =
					sub.status === "ACTIVE"
						? product.isTrial
							? SXMStatus.Trial
							: SXMStatus.Active
						: new Date().getTime() >
								new Date(String(sub.expirationDate)).getTime()
							? SXMStatus.Expired
							: SXMStatus.Inactive;

				if (product.destinationAssist) {
					destinationAssist =
						destinationAssist > status ? destinationAssist : status;
				}
				if (product.dynamicNavigation) {
					dynamicNavigation =
						dynamicNavigation > status ? dynamicNavigation : status;
				}
				if (product.remote) {
					remote = remote > status ? remote : status;
				}
				if (product.safetyConnect) {
					safetyConnect = safetyConnect > status ? safetyConnect : status;
				}
				if (product.serviceConnect) {
					serviceConnect = serviceConnect > status ? serviceConnect : status;
				}
			}
		}
	}

	const features = [
		{
			feature: SXMFeatures.EnformRemote,
			status: remote,
			statusString: SXMStatusStrings?.[remote],
		},
		{
			feature: SXMFeatures.DestinationAssist,
			status: destinationAssist,
			statusString: SXMStatusStrings?.[destinationAssist],
		},
		{
			feature: SXMFeatures.DynamicNavigation,
			status: dynamicNavigation,
			statusString: SXMStatusStrings?.[dynamicNavigation],
		},
		{
			feature: SXMFeatures.SafetyConnect,
			status: safetyConnect,
			statusString: SXMStatusStrings?.[safetyConnect],
		},
		{
			feature: SXMFeatures.ServiceConnect,
			status: serviceConnect,
			statusString: SXMStatusStrings?.[serviceConnect],
		},
	];

	return features.filter((feature) => feature.status !== SXMStatus.Inactive);
}

export default ProductMap;
